import React from 'react'

import { Text } from 'components/dataDisplay'

import OrderItemBase from 'compositions/orderItems/OrderItemBase/OrderItemBase'
import OrderProductBase from 'compositions/orderItems/OrderProductBase/OrderProductBase'
import OrderItemRemoveButton from 'compositions/orderItems/OrderItemRemoveButton/OrderItemRemoveButton'

import messages from './messages'


type GiftSubscriptionOrderItemProps = {
  className?: string
  data: OrderItems.GiftSubscription
  withRemoveButton?: boolean
}

const GiftSubscriptionOrderItem: React.FunctionComponent<GiftSubscriptionOrderItemProps> = (props) => {
  const { className, data: { label, price, months, recipient }, withRemoveButton } = props

  return (
    <OrderItemBase className={className} data-testid="orderGiftSubscription">
      {
        withRemoveButton && (
          <OrderItemRemoveButton
            input={{
              giftSubscriptionItem: {
                months,
                recipient,
              },
            }}
            metadata={{
              productType: 'Gift subscription',
              placement: 'Drawer cart',
            }}
          />
        )
      }
      <OrderProductBase price={price}>
        <Text
          message={messages.oneTime}
          style="h9"
        />
        <Text
          className="mt-8"
          message={label || messages.label}
          style="t2"
        />
        {
          months && (
            <Text
              message={{ ...messages.months, values: { months } }}
              style="p2"
            />
          )
        }
      </OrderProductBase>
    </OrderItemBase>
  )
}


export default GiftSubscriptionOrderItem
